// Si la barra lateral queda fijada, recordado por equipo.
//
// Mismo patrón que temaService.js y zoomDetalleService.js: localStorage y una
// clave. Es una preferencia de la pantalla que se tiene delante, no del
// cajero: en un monitor ancho conviene fijarla y en una tablet de mostrador
// estorba, y la misma persona puede usar los dos en el mismo turno.
const STORAGE_KEY = "barraLateralFijada";

// Por omisión, **sin fijar**.
//
// Es el cambio que se pidió: que el ancho de la ventana sea para el contenido
// --un listado de facturas tiene veinte columnas-- y que el menú aparezca
// encima cuando hace falta. Quien prefiera tenerlo siempre a la vista lo
// clava con el alfiler y no se lo vuelve a preguntar.
const POR_OMISION = false;

export const getBarraFijada = () => {
  try {
    const guardado = localStorage.getItem(STORAGE_KEY);
    if (guardado === null) return POR_OMISION;
    return guardado === "true";
  } catch (error) {
    console.error("Error al leer si la barra lateral está fijada:", error);
    return POR_OMISION;
  }
};

export const setBarraFijada = (fijada) => {
  try {
    localStorage.setItem(STORAGE_KEY, String(!!fijada));
  } catch (error) {
    console.error("Error al guardar si la barra lateral está fijada:", error);
  }
};
